import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/free-regular-svg-icons';
//Components
import MainCard from '../../components/MainCard/MainCard';
import TabelaListagem from '../../components/TabelaListagem/TabelaListagem';
import Loading from '../../components/Loading/Loading';

//Api
import correioInterno_api from '../../api/correioInterno_api';

//Helpers
import { showMessage } from '../../helpers/message';


export default function FichaCorreioInterno({ btnVoltar, id }) {
    //Estado de controle do correio interno
    const [correioInterno, setCorreioInterno] = useState({});
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);
    //cabeçalhos da tabela de mensagens lidas
    const headers = [
        { value: "Nome", objectValue: "nome", align: "left" },
        { value: "Data da leitura", objectValue: "dataLeitura", align: "left" },
        { value: "Módulo", objectValue: "modulo", align: "left" },
    ]

    //Carrega os dados do correio interno
    const loadCorreioInterno = () => {
        setLoading(true);
        correioInterno_api.GetItem(id).then(response => {
            response.data.mensagensLidas = response.data.mensagensLidas.map(value => {
                value.dataLeitura = moment(value.dataLeitura).format("DD/MM/YYYY HH:mm:ss");
                if (value.dataLeitura == "Data inválida") {
                    value.dataLeitura = "Mensagem não lida";
                }
                return value;
            })
            setCorreioInterno(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }
    //Carrega os dados do correio interno assim que a tela é carregada
    useEffect(() => {
        loadCorreioInterno();
    }, []);
    return (
        <MainCard btnVoltar={btnVoltar}>
            {loading && <Loading />}
            <div style={{ color: "#666" }}>
                <h5 className="bg-gradient bg-primary rounded-3 p-2 text-light">{correioInterno.titulo}</h5>
                <Row>
                    <Col md="12" lg="12">
                        <p><span className="fw-bold">Destinatário: </span> {correioInterno.destinatario}</p>
                    </Col>
                    <Col md="12" lg="12">
                        <p><span className="fw-bold">Tipo Envior: </span> {correioInterno.tipoEnvio ?? "Interno"}</p>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" lg="12">
                        <p><span className="fw-bold">Mensagem: </span></p>
                        <div dangerouslySetInnerHTML={{ __html: correioInterno.mensagem }}></div>

                    </Col>
                </Row>
                <h6 className="bg-gradient bg-primary rounded-3 p-2 text-light mb-4">Anexos</h6>
                <Row>
                    {correioInterno.anexos && correioInterno.anexos.map(value => {
                        return (
                            <Col md="6" lg="2">
                                <div className=' text-secondary my-2 shadow d-flex flex-column align-items-center justify-content-center p-2  rounded-3'>
                                    <FontAwesomeIcon icon={faFileAlt} size={'4x'} />
                                    <p className='mt-2'>
                                        <a className='text-decoration-none text-light bg-primary p-1 rounded-3' href={value.caminho}>Baixar</a>
                                    </p>
                                </div>
                            </Col>
                        );
                    })}
                </Row>
                <h6 className="bg-gradient bg-primary rounded-3 p-2 text-light">Mensagens Lidas</h6>
                <TabelaListagem headers={headers} items={correioInterno.mensagensLidas ? correioInterno.mensagensLidas : []} options={{ print: false, search: true, pagination: true }} />
            </div>
        </MainCard >
    )
}